import React, { useState, useEffect } from "react";
import "./AddProductSEO.css";
import InputField from "../../../Components/UI-Controls/InputField/InputField";
import image from "../../../Assets/soho.jpg";
import { FaArrowUp } from "react-icons/fa";

export default function AddProductSEO({ isOpen, onClose, onSave, initialData, mainProduct }) {


    const [seoLoading, setSeoLoading] = useState(false);




    const [seoData, setSeoData] = useState({
        title: "",
        description: "",
        xTitle: "",
        xDescription: "",
        ogTitle: "",
        ogDescription: "",
        keywords: ""
    });

    const [variantsData, setVariantsData] = useState([]);

    // Tracks which variant accordion panels are open, e.g. { "var-1": true }
    const [openVariants, setOpenVariants] = useState({});
    const [openVariantKey, setOpenVariantKey] = useState(null);


    const isVariableProduct =
        !!initialData?.isVariable ||
        (Array.isArray(initialData?.variants) && initialData.variants.length > 0);

    useEffect(() => {
        if (initialData) {
            setSeoData({
                title: initialData.title || "",
                description: initialData.description || "",
                xTitle: initialData.xTitle || "",
                xDescription: initialData.xDescription || "",
                ogTitle: initialData.ogTitle || "",
                ogDescription: initialData.ogDescription || "",
                keywords: Array.isArray(initialData.keywords)
                    ? initialData.keywords.join(", ")
                    : initialData.keywords || ""
            });

            if (Array.isArray(initialData.variants)) {
                const mapped = initialData.variants.map((v) => ({
                    id: v.id,
                    uid: v.uid,
                    image: v.image || image,
                    name: v.name || "",
                    sku: v.sku || "",
                    price: v.price || "",
                    comparePrice: v.comparePrice || "",
                    status: v.status || "Published",
                    title: v.title || "",
                    description: v.description || "",
                    xTitle: v.xTitle || "",
                    xDescription: v.xDescription || "",
                    ogTitle: v.ogTitle || "",
                    ogDescription: v.ogDescription || "",
                    keywords: Array.isArray(v.keywords)
                        ? v.keywords.join(", ")
                        : v.keywords || ""
                }));
                setVariantsData(mapped);

                // First variant open by default, rest collapsed
                setOpenVariantKey(mapped.length > 0 ? (mapped[0].id || 0) : null);
            } else {
                setVariantsData([]);
                setOpenVariantKey(null);
            }
        }
    }, [initialData, isOpen]);

    const handleInputChange = (name, value) => {
        setSeoData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleVariantInputChange = (index, name, value) => {
        setVariantsData((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [name]: value
            };
            return updated;
        });
    };

    const toggleVariant = (key) => {
        setOpenVariantKey((prev) => (prev === key ? null : key));
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        const processedData = {
            ...seoData,
            keywords: seoData.keywords
                .split(",")
                .map((k) => k.trim())
                .filter(Boolean)
        };

        if (isVariableProduct) {
            processedData.variants = variantsData.map((v) => ({
                ...v,
                keywords: v.keywords
                    .split(",")
                    .map((k) => k.trim())
                    .filter(Boolean)
            }));
        }

        if (onSave) onSave(processedData);
    };

    const handleCopyParentSeo = (index) => {
        setVariantsData((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                title: seoData.title,
                description: seoData.description,
                xTitle: seoData.xTitle,
                xDescription: seoData.xDescription,
                ogTitle: seoData.ogTitle,
                ogDescription: seoData.ogDescription,
                keywords: seoData.keywords
            };
            return updated;
        });
    };

    if (!isOpen) return null;

    const renderSeoFields = (data, onFieldChange) => (
        <>
            <div className="seo_section">
                <h3>General SEO</h3>
                <div className="seo_field_group">
                    <label>Meta Title</label>
                    <InputField
                        value={data.title}
                        name="title"
                        onChange={(e) => onFieldChange("title", e.target.value)}
                        placeholder="Enter meta title"
                        width="100%"
                    />
                </div>
                <div className="seo_field_group">
                    <label>Meta Description</label>
                    <textarea
                        className="seo_textarea"
                        value={data.description}
                        onChange={(e) => onFieldChange("description", e.target.value)}
                        placeholder="Enter meta description"
                        rows={3}
                    />
                </div>
            </div>

            <div className="seo_section">
                <h3>Search Keywords</h3>
                <div className="seo_field_group">
                    <label>Keywords (Comma Separated)</label>
                    <InputField
                        value={data.keywords}
                        name="keywords"
                        onChange={(e) => onFieldChange("keywords", e.target.value)}
                        placeholder="e.g. bed, dresser, mirror, nightstand"
                        width="100%"
                    />
                </div>
            </div>

            <div className="seo_section">
                <div className="seo_section_header_row">
                    <h3>Open Graph (Facebook/LinkedIn)</h3>
                    <p
                        onClick={() => {
                            onFieldChange("ogTitle", data.title);
                            onFieldChange("ogDescription", data.description);
                        }}
                    >
                        Copy Parent
                    </p>
                </div>
                <div className="seo_field_group">
                    <label>OG Title</label>
                    <InputField
                        value={data.ogTitle}
                        name="ogTitle"
                        onChange={(e) => onFieldChange("ogTitle", e.target.value)}
                        placeholder="Enter OG title"
                        width="100%"
                    />
                </div>
                <div className="seo_field_group">
                    <label>OG Description</label>
                    <textarea
                        className="seo_textarea"
                        value={data.ogDescription}
                        onChange={(e) => onFieldChange("ogDescription", e.target.value)}
                        placeholder="Enter OG description"
                        rows={3}
                    />
                </div>
            </div>

            <div className="seo_section">
                <div className="seo_section_header_row">
                    <h3>X (Twitter) Card Details</h3>
                    <p
                        onClick={() => {
                            onFieldChange("xTitle", data.title);
                            onFieldChange("xDescription", data.description);
                        }}
                    >
                        Copy Parent
                    </p>
                </div>
                <div className="seo_field_group">
                    <label>X Title</label>
                    <InputField
                        value={data.xTitle}
                        name="xTitle"
                        onChange={(e) => onFieldChange("xTitle", e.target.value)}
                        placeholder="Enter X title"
                        width="100%"
                    />
                </div>
                <div className="seo_field_group">
                    <label>X Description</label>
                    <textarea
                        className="seo_textarea"
                        value={data.xDescription}
                        onChange={(e) => onFieldChange("xDescription", e.target.value)}
                        placeholder="Enter X description"
                        rows={3}
                    />
                </div>
            </div>
        </>
    );

    const renderHeaderBlock = (img, name, sku, price, comparePrice, status) => (
        <div className="product_details_seo_details_section">
            <div className="product_img_pdsds">
                <img src={img} alt="" />
            </div>
            <div className="product_other_details_pdsds">
                <h1>{name}</h1>
                <p>{sku}</p>
                <div className="subheader_podp">
                    <div className="pricing_spodp">
                        <h3>{price}</h3>
                        {comparePrice ? <del>{comparePrice}</del> : null}
                    </div>
                    <div className="product_status_pdsds">{status}</div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="seo_drawer_overlay" onClick={onClose}>
            <div className="seo_drawer_content" onClick={(e) => e.stopPropagation()}>

                {/* Header */}
                <div className="seo_drawer_header">
                    <h2>Product SEO Details</h2>
                    {renderHeaderBlock(
                        mainProduct?.image || image,
                        mainProduct?.name || "Product",
                        mainProduct?.sku || "",
                        mainProduct?.price ? `$${mainProduct.price}` : "",
                        mainProduct?.comparePrice ? `$${mainProduct.comparePrice}` : "",
                        mainProduct?.status || ""
                    )}
                    <button className="close_btn_09" onClick={onClose}>&times;</button>
                </div>

                {/* Form Wrapper */}
                <form onSubmit={handleSubmit} className="seo_drawer_form">

                    {/* Main product SEO fields (always shown, not an accordion) */}
                    {renderSeoFields(seoData, handleInputChange)}

                    {/* Variant SEO accordions (only for variable products) */}
                    {isVariableProduct && variantsData.length > 0 && (
                        <div className="variant_seo_wrapper">
                            <div className="variant_seo_wrapper_title">Product Variants</div>

                            {variantsData.map((variant, index) => {
                                const key = variant.id || index;
                                const isOpenPanel = openVariantKey === key;



                                return (
                                      <div
            className={`variant_accordion_item ${isOpenPanel ? "is_open" : ""}`}
            key={key}
        >
                                        <button
                                            type="button"
                                            className="variant_accordion_trigger"
                                            onClick={() => toggleVariant(key)}
                                        >
                                            {renderHeaderBlock(
                                                variant.image,
                                                variant.name,
                                                variant.sku,
                                                variant.price,
                                                variant.comparePrice,
                                                variant.status
                                            )}
                                            <span className="variant_accordion_chevron"><FaArrowUp /></span>
                                        </button>

                                        {/* {isOpenPanel && (
                                            <div className="variant_accordion_panel">
                                                {renderSeoFields(variant, (name, value) =>
                                                    handleVariantInputChange(index, name, value)
                                                )}
                                            </div>
                                        )} */}

                                        {isOpenPanel && (
                                            <div className="variant_accordion_panel">
                                                <div className="variant_copy_parent_row">
                                                    <div></div>
                                                    <p
                                                        onClick={() => handleCopyParentSeo(index)}
                                                    >
                                                        Copy Parent SEO Details
                                                    </p>
                                                </div>

                                                {renderSeoFields(variant, (name, value) =>
                                                    handleVariantInputChange(index, name, value)
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Sticky Form Actions at bottom */}
                    <div className="seo_drawer_footer">
                        <button type="button" className="cancel_action_btn" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="save_action_btn">
                            Save SEO Settings
                        </button>
                    </div>
                </form>

            </div>
        </div>
    );
}